import React, { Fragment, useCallback } from "react";
import {
  isEditorActive,
  Text,
  Image,
  Link
} from "@sitecore-jss/sitecore-jss-react";
import { CardProps } from "../../types/types";
import { CardModel } from "../../lib/shared-models/card.model";
import "./index.scss";
//dayjs
import dayjs from "dayjs";
import "dayjs/locale/it";
import "dayjs/locale/en";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

const StoriesCard = (props: CardProps) => {
  const model = new CardModel(props);
  const locale = props?.lang ? props.lang : "en";

  const defaultFormat: (Date: Date, Locale: string) => string = (
    date,
    locale
  ) => {
    return dayjs.utc(date).locale(locale).format("YYYY-MM-DD"); //made into SC field "default format"
  };

  const formatted: (Date: Date, Locale: string, Format: string) => string = (
    date,
    locale,
    format
  ) => {
    return dayjs.utc(date).locale(locale).format(format);
  };

  const dateFormatByLocale: (
    Date: Date,
    Locale: string,
    Format?: string
  ) => string = useCallback(
    (date, locale, format) => {
      return date && locale && format?.length === 0
        ? defaultFormat(date, locale)
        : date && format && locale
        ? formatted(date, locale, format)
        : "";
    },

    []
  );

  return (
    <Fragment>
      <div className="stories-card">
        <Fragment>
          <div className="stories-card__bg">
            {isEditorActive() ? (
              <Image
                field={props.fields?.Image}
                className="stories-card__bg-image"
              />
            ) : (
              <>
                <Image
                  loading="lazy"
                  field={{ value: model.imageSrc }}
                  className="stories-card__bg-image desktopImage"
                  alt={model.imageAlt}
                  width={model.imageWidth}
                  height={model.imageHeight}
                  src={model.imageSrc}
                />
                <Image
                  loading="lazy"
                  field={
                    (props?.fields?.imageMobile &&
                    Object.keys(props?.fields?.imageMobile?.value ?? []).length > 0)
                      ? props?.fields?.imageMobile
                      :( props?.fields?.AllowFallbackForMobile?.value ? props.fields?.Image : undefined)
                  }
                  className="stories-card__bg-image mobileImage"
                  alt={model.imageAlt}
                  width={model.imageWidth}
                  height={model.imageHeight}
                />
              </>
            )}
          </div>

          <div className="stories-card__content">
            {model.Date && isEditorActive() ? (
              <Text
                field={model.Date}
                className="stories-card__date"
                tag="div"
              />
            ) : (
              model.Date &&
              model.Date.value !== "0001-01-01T00:00:00Z" && (
                <Text
                  field={{
                    value: dateFormatByLocale(
                      new Date(model.Date?.value ?? ''),
                      locale,
                      model.FormatDate?.value
                    ),
                  }}
                  className="stories-card__date"
                  tag="span"
                />
              )
            )}

            {isEditorActive() ? (
              <Text field={model.title} className="stories-card__link" />
            ) : (
              <Text
                tag="span"
                field={model.title}
                className="stories-card__link"
              />
            )}

            {(model.link?.value?.href || model.link?.value?.text) && (
              <div className="stories-card__story_link">
                <Link field={model.link} />
              </div>
            )}
          </div>
        </Fragment>
      </div>
    </Fragment>
  );
};

export default StoriesCard;
